import {
  ITrackingAction,
  ITrackingObject,
  ITrackingProperties,
  TrackingActionNamesEnum,
} from 'i2g-ng-tracking';

// re-export to be imported by other files
export {
  ITrackingObject,
  ITrackingAction,
  TrackingActionNamesEnum,
  ITrackingProperties,
};

export enum TrackingObjectNamesEnum {
  account = 'account',
  address = 'address',
  auto_list = 'auto_list',
  banner = 'banner',
  blocked_by_email = 'blocked_by_email',
  alert_banner = 'alert_banner',
  canvas = 'canvas',
  client = 'client',
  dialog = 'dialog',
  document = 'document',
  document_list = 'document_list',
  drawer = 'drawer',
  email_verification_lock = 'email_verification_lock',
  feedback = 'feedback',
  file = 'file',
  global_search = 'global_search',
  home_screen = 'home_screen',
  help = 'help',
  input = 'input',
  input_list = 'input_list',
  instant_website = 'instant_website',
  job = 'job',
  manage_autorenew = 'manage_autorenew',
  match_payment = 'match_payment',
  match_payment_payment_list = 'match_payment_payment_list',
  navigation = 'navigation',
  network = 'network',
  offer = 'offer',
  onboarding = 'onboarding',
  performance_metric = 'performance_metric',
  popup = 'popup',
  promo_banner = 'promo_banner',
  profile_read_reviews = 'profile_read_reviews',
  profile_read_reviews_detail = 'profile_read_reviews_detail',
  profile_request_reviews = 'profile_request_reviews',
  raf = 'raf',
  report = 'report',
  report_expanded = 'report_expanded',
  settings = 'settings',
  statement = 'statement',
  survey = 'survey',
  task_list = 'task_list',
  task_list_completion_message = 'task_list_completion_message',
  template_editor = 'template_editor',
  top_navigation = 'top_navigation',
  web_paywall = 'web_paywall',
  web_purchase = 'web_purchase',
  web_purchase_success = 'web_purchase_success',
  notification = 'notification',
  notifications = 'notifications',
}

export enum TrackingObjectDocumentTypesEnum {
  invoice = 'invoice',
  estimate = 'estimate',
  credit_memo = 'credit_memo',
  purchase_order = 'purchase_order',
}

export enum TrackingScreenNamesEnum {
  account_details = 'account_details',
  account_sign_in = 'account_sign_in',
  accumulative_of = 'accumulative_of',
  active_tracked_time = 'active_tracked_time',
  appointment_list = 'appointment_list',
  appointment_search = 'appointment_search',
  bank_transfer_details = 'bank_transfer_details',
  blocked_by_email = 'blocked_by_email',
  canvas = 'canvas',
  change_account_email = 'change_account_email',
  client_communication = 'client_communication',
  client_edit = 'client_edit',
  client_list = 'client_list',
  client_search = 'client_search',
  client_payment_options = 'client_payment_options',
  client_profile = 'client_profile',
  company_profile = 'company_profile',
  copy_document = 'copy_document',
  credit_memo_edit = 'credit_memo_edit',
  credit_memo_list = 'credit_memo_list',
  credit_memo_send = 'credit_memo_send',
  credit_memo_preview = 'credit_memo_preview',
  credit_memo_search = 'credit_memo_search',
  edit_tax = 'edit_tax',
  edit_appointment = 'edit_appointment',
  edit_tracked_time = 'edit_tracked_time',
  email_verification_lock = 'email_verification_lock',
  estimate_edit = 'estimate_edit',
  estimate_list = 'estimate_list',
  estimate_send = 'estimate_send',
  estimate_preview = 'estimate_preview',
  estimate_search = 'estimate_search',
  expense_edit = 'expense_edit',
  expense_list = 'expense_list',
  expense_search = 'expense_search',
  export = 'export',
  global_search = 'global_search',
  home = 'home',
  help = 'help',
  instant_website = 'instant_website',
  invoice_charge_a_card = 'invoice_charge_a_card',
  invoice_deposit_request = 'invoice_deposit_request',
  invoice_edit = 'invoice_edit',
  invoice_list = 'invoice_list',
  invoice_search = 'invoice_search',
  invoice_send = 'invoice_send',
  invoice_preview = 'invoice_preview',
  invoice_payment_history = 'invoice_payment_history',
  item_edit = 'item_edit',
  item_list = 'item_list',
  item_search = 'item_search',
  job_list = 'job_list',
  job = 'job',
  mark_as_paid = 'mark_as_paid',
  match_payment = 'match_payment',
  migration_blocked = 'migration_blocked',
  manage_autorenew = 'manage_autorenew',
  manage_autorenew_payment = 'manage_autorenew_payment',
  manage_autorenew_disable_autorenewal = 'manage_autorenew_disable_autorenewal',
  new_appointment = 'new_appointment',
  navigation = 'navigation',
  onboarding_create_invoice = 'onboarding_create_invoice',
  onboarding_direct_to_invoice = 'onboarding_direct_to_invoice',
  opt_out_trial_landing_page = 'opt_out_trial_landing_page',
  payments_oauth_canvas = 'payments_oauth_canvas',
  payments_underwrite_canvas = 'payments_underwrite_canvas',
  personalization_postpurchase_purchase = 'personalization_postpurchase_purchase',
  personalization_postpurchase_nonpurchase = 'personalization_postpurchase_nonpurchase',
  purchase_order_edit = 'purchase_order_edit',
  purchase_order_list = 'purchase_order_list',
  purchase_order_send = 'purchase_order_send',
  purchase_order_preview = 'purchase_order_preview',
  purchase_order_search = 'purchase_order_search',
  profile_read_reviews = 'profile_read_reviews',
  profile_read_reviews_detail = 'profile_read_reviews_detail',
  profile_request_reviews = 'profile_request_reviews',
  refer_a_friend = 'refer_a_friend',
  reports = 'reports',
  reports_dashboard = 'reports_dashboard',
  search = 'search',
  select_payment = 'select_payment',
  settings = 'settings',
  settings_account = 'settings_account',
  settings_client_communication = 'settings_client_communication',
  settings_company_information = 'settings_company_information',
  settings_company_profile = 'settings_company_profile',
  settings_payments_client_payment_options = 'settings_payments_client_payment_options',
  settings_manage_subscription = 'settings_manage_subscription',
  settings_security = 'settings_security',
  settings_personal_info = 'settings_personal_info',
  settings_team_members = 'settings_team_members',
  settings_language = 'settings_language',
  settings_tax_and_currency = 'settings_tax_and_currency',
  settings_xero = 'settings_xero',
  statement_edit = 'statement_edit',
  statement_preview = 'statement_preview',
  statement_send = 'statement_send',
  task_listed_completion = 'task_listed_completion',
  team_members = 'team_members',
  template_design = 'template_design',
  template_options = 'template_options',
  tracked_time_search = 'tracked_time_search',
  tracked_time_list = 'tracked_time_list',
  view_appointment = 'view_appointment',
  view_tracked_time = 'view_tracked_time',
  web_paywall = 'web_paywall',
  web_purchase = 'web_purchase',
  web_purchase_success = 'web_purchase_success',
}

export enum TrackingDialogNamesEnum {
  account_underwrite = 'account_underwrite',
  add_bulk = 'add_bulk',
  add_estimate = 'add_estimate',
  add_to_calendar = 'add_to_calendar',
  appointments_multiple_select = 'appointments_multiple_select',
  appointment_link_docs = 'appointment_link_docs',
  approve_estimate = 'approve_estimate',
  attachment_error = 'attachment_error',
  bank_transfer_add_client = 'bank_transfer_add_client',
  change_account_email = 'change_account_email',
  confirm_convert_to_invoice = 'confirm_convert_to_invoice',
  confirm_disable_autorenew = 'confirm_disable_autorenew',
  confirm_mark_all_paid = 'confirm_mark_all_paid',
  convert_to_invoice_error = 'convert_to_invoice_error',
  copy_document = 'copy_document',
  create_job = 'create_job',
  create_estimate = 'create_estimate',
  custom_time_period = 'custom_time_period',
  delete_confirmation = 'delete_confirmation',
  delete_file = 'delete_file',
  deposit_enable_payments = 'deposit_enable_payments',
  deposit_enable_payments_again = 'deposit_enable_payments_again',
  deposit_estimate_disabled = 'deposit_estimate_disabled',
  disable_reminders = 'disable_reminders',
  discount = 'discount',
  document_item_options = 'document_item_options',
  estimate_deposit_request = 'estimate_deposit_request',
  expense_image_fullscreen = 'expense_image_fullscreen',
  expenses_multiple_select = 'expenses_multiple_select',
  export_tax_year_selector = 'export_tax_year_selector',
  edit_tax = 'edit_tax',
  invoice_deposit_request = 'invoice_deposit_request',
  invoice_record_transaction = 'invoice_record_transaction',
  items_multiple_select = 'items_multiple_select',
  link_paypal = 'link_paypal',
  payments_invoice_disable_canvas = 'payments_invoice_disable_canvas',
  payments_undo_match = 'payments_undo_match',
  pdf_generate = 'pdf_generate',
  pdf_export_limit_exceeded = 'pdf_export_limit_exceeded',
  reset_numbering = 'reset_numbering',
  send_receipt = 'send_receipt',
  settings_team_members_add_new = 'settings_team_members_add_new',
  settings_team_members_view = 'settings_team_members_view',
  settings_change_account_email = 'settings_change_account_email',
  settings_company_profile_edit_tax = 'settings_company_profile_edit_tax',
  shipping_info = 'shipping_info',
  time_entries_multiple_select = 'time_entries_multiple_select',
  update_client_data = 'update_client_data',
  update_deposit_request = 'update_deposit_request',
  update_email = 'update_email',
  xero_tax_confirmation = 'xero_tax_confirmation',
}

export enum TrackingButtonIdentifierEnum {
  add_new_client = 'add_new_client',
  add_new_expense = 'add_new_expense',
  add_new_item = 'add_new_item',
  add_document = 'add_document',
  add_document_empty_state = 'add_document_empty_state',
  add_file = 'add_file',
  add_input = 'add_input',
  add_input_empty_state = 'add_input_empty_state',
  add_estimate = 'add_estimate',
  create_estimate = 'create_estimate',
  cancel = 'cancel',
  delete = 'delete',
  delete_file = 'delete_file',
  discard_changes = 'discard changes',
  save = 'save',
  send = 'send',
}

export enum TrackingInputTypeValuesEnum {
  appointment = 'appointment',
  client = 'client',
  item = 'item',
  expense = 'expense',
  attachment = 'attachment',
  tracked_time = 'tracked_time',
  job = 'job',
  file_attachment = 'file_attachment',
  estimate = 'estimate',
}

export enum TrackingCanvasCategoryEnum {
  action = 'action',
  informational = 'informational',
}

export enum TrackingCanvasTypeEnum {
  growth = 'growth',
  payments = 'payments',
  sunset = 'sunset',
  documents = 'documents',
}

export enum TrackingCanvasActionEnum {
  cta1 = 'cta1',
  cta2 = 'cta2',
  dismiss = 'dismiss',
}

export enum TrackingPaymentsStatusEnum {
  on = 'on',
  off = 'off',
  ineligible = 'ineligible',
}

export enum TrackingPaymentOptionsEnum {
  account_disabled = 'account_disabled',
  enabled = 'enabled',
  document_disabled = 'document_disabled',
}

export interface IPaymentOptionsAdditionalProperties {
  i2g_money: TrackingPaymentOptionsEnum;
  bank_transfer_debit: TrackingPaymentOptionsEnum;
  card_payments: TrackingPaymentOptionsEnum;
  paypal_ec: TrackingPaymentOptionsEnum;
  revision_id: string;
}

export interface IItemsMultipleSelectAdditionalProperties {
  count: number;
}

export interface IExpensesMultipleSelectAdditionalProperties {
  count: number;
  without_images: boolean;
}

export interface ISortOptionsAdditionalProperties {
  sort_by: string;
  order: string;
}

export interface ITrackingErrorProperties {
  url: string;
  http_code: string;
  correlation_id: string;
  http_message: string;
  description: string;
  internal_code: string;
}

export interface ITrackingTraits {
  accountId: string;
  userId: string;
  country: string;
  currencyCode: string;
  purchaseWindow: string;
  planUuid: string;

  // optional for tracking that use encrypted account id

  email?: string;
  expirationDate?: string;
  cardPaymentsStatus?: string;
}

export interface ITimeEntriesMultipleSelectAdditionalProperties {
  count: number;
}

export interface IFtuAdditionalProperties {
  variant_key: 'ftuv1';
}

export interface IInsightsHubAdditionalProperties {
  insights_hub: boolean;
}
